common.View.create('website_news_override::website.modules.news.Show', {
    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        this.element.find('.owl-carousel').owlCarousel({
            loop: false,
            margin: 50,
            items: 1,
            nav: true,
            dots: false,
            autoplay: false,
            autoplayTimeout: 4444,
            autoplayHoverPause: true,
            stageClass: 'owl-stage flex',
            responsive: {
                0: {
                    items: 1,
                },
                1024: {
                    items: 2,
                },
            },
        });
    },
});
